import React, { useEffect, useState} from 'react';
import SideMenu from '../sideMenu'; 
import DashboardHeader from '../topbar';
import Styles from "./styles.module.scss";
import * as CONSTANTS from '../../utils/CONSTANTS'
import { makeSideBarActive } from '../../utils/EllowUtils';
import { TabStrip } from "@progress/kendo-react-layout";
import Tab from '../../components/tab';
import {
  TabStripSelectEventArguments,
} from "@progress/kendo-react-layout";
import {getIncontractCandidates } from './services'
import InContractTab from './inContractTab';
import { viewedpageMixpanel } from '../../utils/mixpanel';


function IncontractResources() {

  const menu = makeSideBarActive(CONSTANTS.sideMenu, 1)
  let BreadcrumsValues = ['Resources in Contract']
  const customerId = localStorage.getItem('customerId') || ''
  const [openContractData, setOpenContractData] = useState<any>()
  const [closedContractData, setClosedContractData] = useState<any>()
  const [openTotal, setOpenTotal] = useState<number>()
  const [closeTotal, setCloseTotal] = useState<number>()
  const [selectedTab, setSelectedTab] = useState<number>(0);
  localStorage.removeItem('candidateLoginId');
  const [filterNumber, setFilterNumber] = useState<number>();
  const [sort, setSort] = useState<any>([]);
  const [filterValues, setFilterValues] = useState<any>(null);

  useEffect(() => {

    getIncontractResources( 'open', customerId, '', '','')
    getIncontractResources( 'closed', customerId, '', '', '')
    viewedpageMixpanel()


  }, [customerId])

  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelectedTab(e.selected)
    
  }


  const getIncontractResources = (tab: string, customerId: string, search: string, filters?: any, sort?: any) => {

    let body: any = {}
    if (filters) {
      body =  {
        "providerCompanyId": customerId,
          filters,
        "sort":{
           "sortBy": sort && sort.length > 0 ? sort[0] && sort[0].field : 'candidateName',
           "sortOrder": sort && sort.length > 0  ? sort[0] && sort[0].dir : 'ASC'
        }
    }
    }
    else {
      body =  {
        "providerCompanyId": customerId,
        "filters": {},
        "sort":{
           "sortBy": sort && sort.length > 0  ? sort[0] && sort[0].field : 'candidateName',
           "sortOrder": sort && sort.length > 0  ? sort[0] && sort[0].dir : 'ASC'
        }
    }
    }

    getIncontractCandidates(tab, search, body).then((response) => {
      if (response && response.status === 1) {
        switch (tab){
          case 'open':            
            setOpenContractData(response.data)
            setOpenTotal((response.data).length)
            break
          case 'closed':            
            setClosedContractData(response.data)
            setCloseTotal((response.data).length)

          }
      }
    });
  };
 

 const Active = <>Active Contracts<i>{openTotal}</i></>
 const Closed = <>Closed Contracts<i>{closeTotal}</i></>
  
 const applyFilter = (data: any) => {
    
  setFilterValues(data.filters)
  getIncontractResources( 'open', customerId, '', data.filters, sort)
  getIncontractResources( 'closed', customerId, '', data.filters, sort)
  setFilterNumber(1)
};

const closeTag = (data: any) => { 

 getIncontractResources( 'open', customerId, '', '','')
 getIncontractResources( 'closed', customerId, '', '', '')

}
const searchChange = (e: string) => {

  getIncontractResources( 'open', customerId, e, '', sort)
  getIncontractResources( 'closed', customerId, e, '', sort)

};

  const applySort = (sort: any) => {
  getIncontractResources( 'open', customerId, '', '', sort)
  getIncontractResources( 'closed', customerId, '', '', sort)
}


  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} openresource={'incontract'} />
      <div className="dashboardContent">
      <DashboardHeader
          title={BreadcrumsValues}
          applyIncontractResourceFilter={applyFilter}
          type='incontractresources'
          filterNumber={filterNumber}
          filterValues={filterValues}
          searchChange={searchChange}      
          closeTag={closeTag}
                 />
     
        <section className={Styles.dashboardWrapper}>
          <TabStrip selected={selectedTab} onSelect={handleSelect}>
            <Tab title={Active} >
              <InContractTab data={openContractData} setSort={setSort} applySort={applySort} />
              </Tab>
            <Tab title={Closed} >
              <InContractTab data={closedContractData} setSort={setSort} applySort={applySort}/>
              </Tab>   
          </TabStrip>
        </section>
      </div>
    </section>
  )
}

export default IncontractResources
